export default __webpack_public_path__ + "static/media/view3_year_age_.4298ee5d.csv";